import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import ClientsDataTable from '../../components/Tables/ClientsDataTable'

const Clients = () => {
    return (

        <AdminSidebarLayout currentPath="/clients">
            <div className="bg-[#F5F5F5] dark:bg-[#121212] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <ClientsDataTable/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default Clients